module.exports = __webpack_public_path__ + "static/media/Cleansed_FZ_TSB_ORX_VENTILATION.2256c2bb.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdf/informatics/Cleansed_FZ_TSB_ORX_VENTILATION.pdf
// module id = 408
// module chunks = 0